(() => {
  const LOG = true;
  const log = (...a) => LOG && console.log('[variant-fix]', ...a);
  const warn = (...a) => console.warn('[variant-fix]', ...a);

  const norm = (s) => (s || '').toString().trim().toLowerCase();

  // verhindert Loop, wenn wir selbst radios klicken
  let isAutoSwitching = false;

  function getVariants(root) {
    const local = root.querySelector('script[type="application/json"][data-variants]');
    if (local) {
      try {
        const v = JSON.parse(local.textContent);
        return Array.isArray(v) ? v : null;
      } catch (e) {
        warn('variants JSON parse error', e);
        return null;
      }
    }
    return null;
  }

  function getGroups(root) {
    return Array.from(root.querySelectorAll('fieldset.product-form__input'));
  }

  function getSelected(root) {
    return getGroups(root).map(fs => fs.querySelector('input[type="radio"]:checked')?.value ?? null);
  }

  function findExactAvailable(variants, selected) {
    const sel = selected.map(norm);
    return variants.find(v => {
      if (!v.available) return false;
      const opts = [v.option1, v.option2, v.option3].filter(Boolean).map(norm);
      return opts.length === sel.length && opts.every((o, i) => o === sel[i]);
    }) || null;
  }

  function findBestAvailable(variants, selected, changedIndex) {
    const exact = findExactAvailable(variants, selected);
    if (exact) return exact;

    const sel = selected.map(norm);
    const keep = sel[changedIndex];

    const keepMatch = variants.find(v => {
      if (!v.available) return false;
      const opts = [v.option1, v.option2, v.option3].filter(Boolean).map(norm);
      return opts[changedIndex] === keep;
    });
    if (keepMatch) return keepMatch;

    return variants.find(v => v.available) || null;
  }

  function applyVariant(root, variant) {
    if (!variant) return;

    const target = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    const groups = getGroups(root);

    isAutoSwitching = true;

    target.forEach((val, idx) => {
      const fs = groups[idx];
      if (!fs) return;
      const radio = Array.from(fs.querySelectorAll('input[type="radio"]'))
        .find(r => norm(r.value) === norm(val));
      if (radio && !radio.checked) radio.click(); // triggert Theme-Logik
    });

    // variant param aktualisieren
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    // lock nach kurzem Tick lösen (damit Change-Events durch sind)
    setTimeout(() => { isAutoSwitching = false; }, 0);
  }

  // ==============
  // 1) Event Delegation: funktioniert auch, wenn variant-selects ersetzt wird
  // ==============
  function onAnyVariantChange(e) {
    if (isAutoSwitching) return;

    const input = e.target;
    if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;

    const root = input.closest('variant-selects');
    if (!root) return;

    const variants = getVariants(root);
    if (!variants?.length) {
      // Falls du mal auf einer alten Section landest ohne JSON
      warn('No variants JSON found in this variant-selects', root);
      return;
    }

    const groups = getGroups(root);
    const selected = getSelected(root);
    if (selected.some(x => x == null)) return;

    const changedFs = input.closest('fieldset.product-form__input');
    const changedIndex = Math.max(0, groups.indexOf(changedFs));

    const exactAvail = findExactAvailable(variants, selected);
    if (exactAvail) return;

    const best = findBestAvailable(variants, selected, changedIndex);
    if (!best) return;

    log('Auto-switch to available variant', best.id, best.option1, best.option2, best.option3);
    applyVariant(root, best);
  }

  // ==============
  // 2) MutationObserver: loggt und hilft beim Debug, aber Delegation reicht schon.
  //    Wir nutzen es zusätzlich, um zu sehen, dass Re-render passiert.
  // ==============
  function observeRerenders() {
    const container = document.querySelector('product-info') || document.body;
    const mo = new MutationObserver((mutations) => {
      // Wenn variant-selects neu ins DOM kommt, loggen wir das
      for (const m of mutations) {
        for (const node of m.addedNodes || []) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('variant-selects')) {
            log('variant-selects added/replaced', node.id || node);
          } else if (node.querySelector?.('variant-selects')) {
            const vs = node.querySelector('variant-selects');
            log('variant-selects added inside subtree', vs.id || vs);
          }
        }
      }
    });
    mo.observe(container, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    log('loaded');
    // Capture = true, damit wir es sicher vor anderen Handlern erwischen
    document.addEventListener('change', onAnyVariantChange, true);
    observeRerenders();
  });
})();
